import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const DiscountContext = createContext()

const DiscountProvider = ({ children }) => {
    const { headers, toast, restaurantId } = useAuth();

    const getAllDiscount = async (filter) => {
        const { totalRenderedRecords, limit, filter: discountFilter } = filter

        try {
            const { data } = await axios.get(`${baseURL}/discount/list?limit=${limit ? limit : null}&totalRenderedRecords=${totalRenderedRecords >= 0 ? totalRenderedRecords : null}&restaurant_id=${restaurantId ? restaurantId : null}&filter=${discountFilter !== '' ? discountFilter : null}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Discount', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const getSingleDiscount = async (id) => {
        try {
            let { data } = await axios.get(`${baseURL}/discount/single-discount/${id}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Discount', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const createDiscount = async (discountDetail) => {
        try {            
            const { data } = await axios.post(`${baseURL}/discount/create`, discountDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Discount', detail: data.message, life: 3000 })
                }, 500);
                return data;
            } else {
                toast.current?.show({ severity: 'error', summary: 'Discount', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    toast.current?.show({ severity: 'error', summary: 'Discount', detail: errors[0].msg, life: 3000 })
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Discount', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const updateDiscount = async (id, discountDetail) => {
        try {
            const { data } = await axios.put(`${baseURL}/discount/update/${id}`, discountDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Discount', detail: data.message, life: 3000 })
                }, 500);
                return data;
            } else {
                toast.current?.show({ severity: 'error', summary: 'Discount', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    toast.current?.show({ severity: 'error', summary: 'Discount', detail: errors[0].msg, life: 3000 })
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Discount', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const deleteDiscount = async (id) => {
        try {
            const { data } = await axios.delete(`${baseURL}/discount/delete/${id}`, { headers });
            if (data.error === false) {
                toast.current.show({ severity: 'success', summary: 'Discount', detail: data.message, life: 3000 })
            } else {
                toast.current.show({ severity: 'error', summary: 'Discount', detail: data.message, life: 3000 })
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Discount', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    return (
        <DiscountContext.Provider value={{ getAllDiscount, getSingleDiscount, createDiscount, updateDiscount, deleteDiscount }}>
            {children}
        </DiscountContext.Provider>
    )
}

const useDiscount = () => useContext(DiscountContext)

export { useDiscount, DiscountProvider }